module.exports = __webpack_public_path__ + "8a5356e9/img/arrow-share-icon.00a12c29.svg";